import React from 'react';
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#3c7e2d73',
    },
    '&:hover fieldset': {
      borderColor: '#3c7e2d',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3c7e2d',
    },
  },
}));

export default function TagInputs(props) {
  const currentDate = new Date().toISOString().split('T')[0];
  
  let minDate, maxDate;
  if (props?.type === 'time') {
    minDate = props?.min || '';
  } else {
    if (props.dateRestriction === 'current') {
      minDate = currentDate;
      maxDate = currentDate;
    } else if (props.dateRestriction === 'past') {
      maxDate = currentDate;
    } else if (props.dateRestriction === 'future') {
      minDate = currentDate;
    }
  }

  const renderInput = () => {
    switch (props.type) {
      case 'select':
        return (
          <StyledFormControl>
            {props.label && <InputLabel>{props.label}</InputLabel>}
            <Select
              value={props.value}
              onChange={props.onChange}
              name={props.name}
              disabled={props.disabled}
              size="small"
            >
              {props.options?.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label || option.name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        );

      case 'R-select':
        return (
          <StyledFormControl>
            {props.label && <InputLabel>{props.label}</InputLabel>}
            <Select
              value={props.value}
              onChange={props.onChange}
              name={props.name}
              disabled={props.disabled}
              multiple={props.isMulti}
              size="small"
              onBlur={props.onBlur}
            >
              {props.options?.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
        );

      case 'textArea':
        return (
          <TextField
            multiline
            rows={2}
            fullWidth
            variant="outlined"
            value={props.value}
            onChange={props.onChange}
            name={props.name}
            disabled={props.disabled}
            label={props.label}
            InputProps={{
              readOnly: props.readOnly
            }}
          />
        );

      case 'date':
      case 'time':
        return (
          <TextField
            type={props.type}
            fullWidth
            variant="outlined"
            value={props.value}
            onChange={props.onChange}
            name={props.name}
            disabled={props.disabled}
            label={props.label}
            InputProps={{
              readOnly: props.readOnly
            }}
            inputProps={{
              min: minDate,
              max: maxDate
            }}
            size="small"
          />
        );

      default:
        return (
          <TextField
            type={props.type === "password" ? "password" : (props?.variation ? "number" : "text")}
            fullWidth
            variant="outlined"
            value={props.value}
            onChange={props.onChange}
            name={props.name}
            disabled={props.disabled}
            label={props.label}
            placeholder={props?.placeholder}
            InputProps={{
              readOnly: props.readOnly
            }}
            inputProps={{
              step: props.variation ? "any" : undefined
            }}
            size="small"
            sx={props?.style}
          />
        );
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {props.label && props.type !== 'select' && props.type !== 'textArea' && (
        <Typography 
          variant="subtitle2" 
          sx={{ mb: 1, color: 'text.secondary' }}
        >
          {props.label}
        </Typography>
      )}
      {renderInput()}
    </Box>
  );
}
